<!-- https://vuetifyjs.com/en/api/v-data-table/#api-props  -->
<!-- This is a data table with dynamically generated headers using props to change url -->
<template>
    <v-row justify-md="center" wrap>
        <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true" :cardShowActions="false"
            cardColor="secondary">
            <template v-slot:crdInner>
                <MaterialfyBasicCard cardMinWidth="300" cardTitle="BOT Automatico" :cardShowSubHeader="false"
                    :cardShowAvatar="false">
                    <template v-slot:crdInner>
                        <validation-observer ref="observer" v-slot="{ invalid }" name="observer">
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-row no-gutters style="flex-wrap: nowrap;">
                                    <v-col cols="2" xs="0" sm="0" md="2" class="flex-grow-0 flex-shrink-0">
                                    </v-col>
                                    <v-col cols="8" xs="0" sm="0" md="8" class="flex-grow-0 flex-shrink-0">
                                        <div v-show="isBot">
                                            <validation-provider v-slot="{ errors }" name="Exchange" rules="required">
                                                <v-text-field v-model="exchange.exchange" :error-messages="errors"
                                                    label="Exchange" readonly disabled></v-text-field>
                                            </validation-provider>
                                        </div>
                                        <div v-show="!isBot">
                                            <validation-provider v-slot="{ errors }" name="Exchange" rules="required">
                                                <v-select v-model="exchange" :items="itemsExchange" item-text="exchange"
                                                    item-value="id" label="Selecciona el Exchange" persistent-hint
                                                    return-object single-line></v-select>
                                                <div class="invalid-feedback">
                                                    <p style="color:red">{{ errors[0] }}</p>
                                                </div>
                                            </validation-provider>
                                        </div>
                                        <validation-provider v-slot="{ errors }" name="Total Bot" rules="required">
                                            <v-text-field v-model="amount" :error-messages="errors" label="Total Bot"
                                                required></v-text-field>
                                        </validation-provider>
                                        <br>
                                        <v-row no-gutters>
                                            <v-col cols="4" xs="0" sm="0" md="5">
                                            </v-col>
                                            <v-col cols="4" xs="2" sm="2" md="2">
                                                <v-row no-gutters justify="center">
                                                    <v-btn :loading="loading" :disabled="invalid" color="success"
                                                        @click="prepareData">Guardar</v-btn>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <br>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </validation-observer>
                    </template>
                </MaterialfyBasicCard>
            </template>
        </MaterialfyColorCard>
        <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
            :float-right="right">
            <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
            <div>
                {{ msg_toast }}
            </div>
            <v-icon size="16" @click="closeAlert">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-row>
</template>

<script>
import UserService from '@/services/user.service'
import User from '@/models/user'
import Client from '@/models/client'
import Bot from '@/models/bot'
import Suscripcion from '@/models/suscripcion'
import { required, email, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
// import { genericApi } from "../../plugins/axios"

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} no puede estar vacio.',
})

extend('max', {
    ...max,
    message: '{_field_} no puede ser mayor de {length} caracteres,',
})

extend('email', {
    ...email,
    message: 'Email debe ser valido.',
})

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        // DialogMessages
        // Asistente
    },
    props: {
        mode: {
            type: String,
            default: 'create',
            validator: (value) => ['create', 'edit'].includes(value)
        },
        data: {
            type: Object,
            default: null
        },
        showHeader: {
            default: true
        },
        activateBreakpoint: {
            default: 0
        },

    },
    data: () => ({
        // Variables Pantalla
        title: 'CREA TU BOT',
        // Objetos
        user: new User(),
        client: new Client(),
        bot: new Bot('', '', '', ''),
        idBot: '',
        suscripcion: new Suscripcion(''),
        // idSuscripcion: '',
        // Items
        itemsExchange: [],
        // Models
        valid: '',
        exchange: '',
        pair: '',
        amount: '',
        isPremium: false,
        errors: '',
        // Variables
        content: '',
        message: '',
        // Condicionales
        isBot: false,
        optionalShow: false,
        successful: false,
        isOpenDialog: false,
        // 18012025 Se añade nueva mejora LOADING INICIO
        loader: null,
        loading: false,
        // 18012025 Se añade nueva mejora LOADING FIN  

        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackbar: false,
        msg_toast: '',
    }),

    computed: {

    },
    // called when page is created before dom to load data from api
    created() {
        // console.log(this.mode)
        UserService.getClients().then(
            response => {
                if (response.data !== '') {
                    for (let i = 0; i < response.data.length; i++) {
                        let aux = { 'id': response.data[i]['id'], 'exchange': response.data[i]['exchange']['exchange'] }
                        this.itemsExchange.push(aux);
                    }
                }
            },
            error => {
                this.content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
    },
    mounted() {
        this.suscripcion = this.data
        if (this.mode === 'edit') {
            this.chargeBot(this.suscripcion.bot.id)
        }
    },
    methods: {
        chargeBot(value) {
            UserService.getBot(value).then(
                response => {
                    // console.log(response.data)
                    this.content = response.data
                    this.idBot = this.content.id
                    this.client.id = this.content.client.id
                    this.exchange = this.content.client.exchange
                    this.pair = this.content.pair
                    this.amount = this.content.amount
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        prepareData() {
            // 18012025 Se añade nueva mejora LOADING INICIO
            this.loader = 'loading'
            this.loading = true
            // 18012025 Se añade nueva mejora LOADING FIN
            this.submitted = true
            this.bot.user = this.suscripcion.user
            this.bot.amount = this.amount
            this.bot.quantity = 0
            this.bot.client = this.client
            this.bot.pair = this.pair
            this.bot.intCompuesto = true
            this.bot.riesgo = null
            this.bot.gest_riesgo = 0

            console.log(this.suscripcion.bot)
            if (this.mode === 'create') {
                this.client.id = this.exchange['id']
                this.suscripcion.bot = this.bot
                console.log('ENTRA EN SAVE BOT')
                this.newBot()

            } else {
                this.bot.id = this.idBot
                console.log('ENTRA EN UPDATE BOT')
                this.saveBot()
            }
        },
        newBot() {
            UserService.postAutoSaveBot(this.suscripcion).then(
                response => {
                    this.content = response
                    setTimeout(() => (this.responseSave('success', this.content)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
                }
            );
        },
        saveBot() {
            console.log(this.bot)
            UserService.postUpdateAutoBot(this.bot).then(
                response => {
                    this.content = response
                    setTimeout(() => (this.responseSave('success', this.content)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                    setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
                }
            );
        },
        responseSave(response, msg) {
            this.top = true;
            this.bottom = true;
            this.left = false;
            this.right = false;
            this.msg_toast = msg
            this.snackbar = true;

            if (response === 'success') {
                this.color = 'success'
                this.successful = true
            } else {
                this.color = 'error'
                this.successful = false
            }
        },
        closeAlert() {
            this.snackbar = false
            this.loading = false
            if (this.successful) {
                this.$router.push('/user-bots');
            } else {
                this.$router.go()
            }
        }
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
